import {DEFAULT_CONTROLS} from "../model/consts";
import {VideoControl} from "../model/types";

export const normalizeControls = (
    controls: boolean | VideoControl[] | undefined,
): VideoControl[] => {

    if (controls === false) return [];

    if (controls === true || controls == null) return DEFAULT_CONTROLS;

    return controls;
};
